import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=ef38f1f0&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=ef38f1f0&lang=scss&scoped=true&"
import style1 from "./invoice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef38f1f0",
  null
  
)

export default component.exports